export default {
      id: "help-center-rocket-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "icons.svg#help-center-rocket",
      toString: function () {
        return this.url;
      }
    }